import React, { Fragment, useContext, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import H3 from '../Headings/H3Element';
import CustomizerContext from '../../_helper/Customizer';
import SvgIcon from '../../Components/Common/Component/SvgIcon';
import DropdownCommon from '../../Components/Common/Dropdown';
import { H5, H6, UL, LI, P } from '../../AbstractElements';

const DRTScrumbs = (props) => {
  
  const DailyDropdownInit = [ "Select", "Apply for User", "Withdraw Application", "End Application Period", "Create Board Pack",  "Change Qualifying Mark", "Start Meeting", "Evaluation Report (PDF)", "Notify Applicants", "Print Application Form", "Search for Application"];
  const DailyDropdown2Init = [ "Select", "Start Meeting", "Change Qualifying Mark", "Evaluation Report", "Search for Application"];

  const [DailyDropdown, setDailyDropdown] = useState(DailyDropdownInit);
  const [DailyDropdown2, setDailyDropdown2] = useState(DailyDropdown2Init);
  
  if(props.schemeParameters!=null&&props.schemeParameters!=undefined){

    if(props.schemeParameters.evaluation_meeting_ended){//applications_period_ended applicants_notified evaluation_concluded
      DailyDropdown2[1]="Start Meeting";
      DailyDropdown[6]="Start Meeting";
    }
    else{
      DailyDropdown2[1]="End Meeting";
      DailyDropdown[6]="End Meeting";
    }

    if(props.schemeParameters.applications_period_ended){
     
      DailyDropdown[3]="Start Application Period";
    }
    else{
      
      DailyDropdown[3]="End Application Period";
    }
   // setDailyDropdown2(DailyDropdown2);
    //setDailyDropdown(DailyDropdown);
  }
  else{

  }
  

  return (
    <Fragment>
      <Container fluid={true}>
        <div className='page-title' style={{margin:0,paddingTop:0, textAlign:"center", align:"center",borderRadius: "0.7rem", backgroundColor:"#ffffff"}}><br />
          <Row>
            <Col xs='12' style={{textAlign: 'left',color:"#6ec6ec"}}>
              <H3 style={{color:"#6ec6ec"}}><span style={{color:"#6ec6ec"}}>{props.mainTitle}</span></H3>
            </Col>
            
            </Row>
            <Row>
            <Col xs='12' style={{textAlign: 'right'}}>
              <ol className='breadcrumb'>
                {
                  props.eng!=undefined&&props.eng!=null&&props.eng=="secretariat"? (
                    
                    <li className='breadcrumb-item'>
                      
          <div className='header-top'>
          {"Secretariat Menu:"}
            <div className='card-header-right-icon' style={{width:'190px'}}>
              <DropdownCommon schemeParameters={props.schemeParameters} thisToggle={props.thisToggle} eng="secretariat" icon={false} options={DailyDropdown} btn={{ caret: true }} />
            </div>
          </div>

                    </li>):(

                        props.eng!=undefined&&props.eng!=null&&props.eng=="chairperson"? (
                    
                          <li className='breadcrumb-item'>
    
                           <div className='header-top'>
                              {"Chairperson Menu:"}
                            <div className='card-header-right-icon' style={{width:'190px'}}>
                            <DropdownCommon schemeParameters={props.schemeParameters} thisToggle={props.thisToggle} eng="chairperson" icon={false} options={DailyDropdown2} btn={{ caret: true }} />
                            </div>
                          </div>

                          </li>):null    

                       )
                }
                <li className='breadcrumb-item'>
                  <Link to={`${process.env.PUBLIC_URL}/eservices/home`}>
                    <SvgIcon iconId='stroke-home' />
                  </Link>
                </li>
                <li className='breadcrumb-item'><Link to={`${process.env.PUBLIC_URL}/eservices/home`}>{props.parent} </Link></li>
                {props.subParent ? <li className='breadcrumb-item'>{props.subParent}</li> : ''}
                {props.eng!=undefined&&props.eng!=null&&props.eng=="secretariat"? null:
                (<li className='breadcrumb-item'>{props.title}</li>)}
              </ol>
            </Col>
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default DRTScrumbs;
